import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { useQuery } from '@tanstack/react-query';
import { AlertTriangle } from 'lucide-react';
import { NotionTaskModalProvider } from '@/contexts/NotionTaskModalContext';
import { GlobalTaskModalProvider } from '@/contexts/GlobalTaskModalContext';
import { NotionTaskDetailModal } from '@/features/notion/components/NotionTaskDetailModal';
import { Toaster } from '@/components/ui/toaster';
import { ConfirmProvider } from '@/components/ui/confirm-dialog';
import { SentryRouteObserver } from '@/observability/sentry.router';
import { UpdateAvailableModal } from '@/components/UpdateAvailableModal';
import { platformSettingsService } from '@/features/branding/services/platform-settings.service';

function RootComponent() {
  const { data: publicSettings } = useQuery({
    queryKey: ['public-platform-settings'],
    queryFn: () => platformSettingsService.getPublic(),
    staleTime: 60_000,
    retry: false,
  });

  const showBanner =
    publicSettings?.maintenance_mode === true && !!publicSettings?.maintenance_message;

  return (
    // ConfirmProvider por fora: os providers de modal renderizam modais que usam useConfirm.
    <ConfirmProvider>
      <NotionTaskModalProvider>
        <GlobalTaskModalProvider>
          <SentryRouteObserver />
          {showBanner && (
            <div className="fixed top-0 left-0 right-0 z-[9999] bg-yellow-400 text-yellow-950 text-xs font-medium text-center py-2 px-4 flex items-center justify-center gap-2">
              <AlertTriangle className="h-3.5 w-3.5 flex-shrink-0" />
              <span>{publicSettings!.maintenance_message}</span>
            </div>
          )}
          <div className={showBanner ? 'pt-9' : undefined}>
            <Outlet />
          </div>
          <NotionTaskDetailModal />
          <UpdateAvailableModal />
          <Toaster />
          {import.meta.env.DEV && <TanStackRouterDevtools />}
        </GlobalTaskModalProvider>
      </NotionTaskModalProvider>
    </ConfirmProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
